/**
 * @prettier
 */
export const layout = {};
